import React from "react";
import Signin from "./Signin";

const SessionRoutes = [
  { path: "/signin/", element: <Signin /> }
];

export default SessionRoutes;
